import { DEFAULT_PAGINATION } from "../../../../../common/query/defaults";
import { MessageSenderListQuery, MessageTemplateListQuery, RequisiteTypeListQuery } from "./query.types";

export const DEFAULT_REQUISITE_TYPE_QUERY: RequisiteTypeListQuery = {
  ...DEFAULT_PAGINATION,
  perPage: 99,
  enabled: true
  // Расширяем любыми query параметрами
}

export const DEFAULT_MESSAGE_TEMPLATE_QUERY: MessageTemplateListQuery = {
  ...DEFAULT_PAGINATION,
  // Расширяем любыми query параметрами
}

export const DEFAULT_MESSAGE_SENDER_QUERY: MessageSenderListQuery = {
  ...DEFAULT_PAGINATION,
  // Расширяем любыми query параметрами
}
